import { createFileRoute, Outlet, redirect } from '@tanstack/react-router'
import { AppShell } from '@/shared/components/layout/AppShell'
import { useAppStore } from '@/shared/stores/appStore'

export const Route = createFileRoute('/_authenticated')({
  beforeLoad: async ({ context, location }) => {
    await context.auth.ready  // prevent auth timing race on first load
    const session = useAppStore.getState().session  // read fresh after authReady resolves
    if (!session) {
      throw redirect({
        to: '/entrar',
        search: { redirect: location.href, code: undefined, error: undefined },
      })
    }
    return { session }
  },
  component: AuthenticatedLayout,
})

function AuthenticatedLayout() {
  return (
    <AppShell>
      <Outlet />
    </AppShell>
  )
}
